import { Center, Icon, Spinner } from '@chakra-ui/react';
import { ModalCloseButton } from '@/ui/ModalClosebutton';
import { ChevronLeft, ChevronRight } from '@kula-ai/icons-core';

const isSameAppId = (a: unknown, b: unknown) => {
  if (a === null || a === undefined) return false;
  if (b === null || b === undefined) return false;
  return String(a) === String(b);
};

export const SliderButtons = ({
  onClose = () => {},
  onPrev = () => {},
  onNext = () => {},
  applications = [],
  application = { appId: '0' },
  showNavItems = true,
  nextDisabled = false,
  prevDisabled = false,
}) => {
  const isAtLast = isSameAppId(
    applications?.[applications?.length - 1]?.appId,
    application?.appId
  );
  const isAtFirst = isSameAppId(applications?.[0]?.appId, application?.appId);

  // Two visually-distinct held states so a warming neighbor never looks like the
  // end of the list:
  //  • boundary (first/last)      → dimmed chevron, not-allowed cursor
  //  • target not cached yet      → spinner, progress cursor ("fetching next…")
  // The arrow stays non-clickable while warming so navigation never lands on a
  // cold spinner, but it now reads as loading, not broken.
  const isNextLoading = nextDisabled && !isAtLast;
  const isPrevLoading = prevDisabled && !isAtFirst;
  const isNextBlocked = isAtLast || nextDisabled;
  const isPrevBlocked = isAtFirst || prevDisabled;

  return (
    <>
      <ModalCloseButton onClose={onClose} />
      {showNavItems && (
        <>
          {' '}
          <Center
            role="button"
            aria-label="Next candidate"
            aria-disabled={isNextBlocked}
            aria-busy={isNextLoading}
            w="48px"
            h="48px"
            left="-60px"
            top="86px"
            pos="absolute"
            borderRadius="full"
            bg="#fff"
            cursor={
              isNextLoading
                ? 'progress'
                : isNextBlocked
                  ? 'not-allowed'
                  : 'pointer'
            }
            onClick={isNextBlocked ? undefined : onNext}
            opacity={isNextBlocked && !isNextLoading ? 0.5 : 1}
            data-test-id="next-candidate-job-application-details-icon"
          >
            {isNextLoading ? (
              <Spinner
                size="sm"
                thickness="2px"
                speed="0.7s"
                color="secondary-500"
              />
            ) : (
              <Icon as={ChevronRight} w="24px" h="24px" />
            )}
          </Center>
          <Center
            role="button"
            aria-label="Previous candidate"
            aria-disabled={isPrevBlocked}
            aria-busy={isPrevLoading}
            w="48px"
            h="48px"
            left="-60px"
            top="140px"
            pos="absolute"
            borderRadius="full"
            bg="#fff"
            cursor={
              isPrevLoading
                ? 'progress'
                : isPrevBlocked
                  ? 'not-allowed'
                  : 'pointer'
            }
            onClick={isPrevBlocked ? undefined : onPrev}
            opacity={isPrevBlocked && !isPrevLoading ? 0.5 : 1}
            data-test-id="previous-candidate-job-application-details-icon"
          >
            {isPrevLoading ? (
              <Spinner
                size="sm"
                thickness="2px"
                speed="0.7s"
                color="secondary-500"
              />
            ) : (
              <Icon as={ChevronLeft} w="24px" h="24px" />
            )}
          </Center>
        </>
      )}
    </>
  );
};
